export default __webpack_public_path__ + "static/media/SWT0370.34I-18855_-14621_0.f835fd63.jpg";